module.exports = __webpack_public_path__ + "img/bad-session-3.d5dafea7.png";